import React from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material'
import { useRatesContext } from '../Rates.context'
import { useAppSelector } from 'src/hooks'
import { selectUserEnvironmentDataList } from 'src/redux'

const EnvironmentSelector: ReactFC = () => {
  const {
    environmentId,
    setEnvironmentId,
    loading: ratesContextLoading
  } = useRatesContext()

  const userEnvironmentDataList = useAppSelector(selectUserEnvironmentDataList)

  const handleChangeSelectedEnvironment = (event: SelectChangeEvent) => {
    const value = event.target.value
    setEnvironmentId(value)
  }

  return (
    userEnvironmentDataList && (
      <FormControl
        sx={{
          marginTop: '4px',
          width: '300px',
          '& > *, & .MuiSvgIcon-root': {
            color: 'white !important'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'white !important'
          }
        }}
        size='small'
      >
        <InputLabel id='selectedEnvironment'>Entorno seleccionado</InputLabel>
        <Select
          label='selectedEnvironment'
          onChange={(e) => {
            handleChangeSelectedEnvironment(e)
          }}
          value={
            userEnvironmentDataList.length > 1
              ? environmentId ?? ''
              : userEnvironmentDataList[0].id
          }
          disabled={userEnvironmentDataList.length <= 1 || ratesContextLoading}
        >
          {userEnvironmentDataList?.map((environment) => (
            <MenuItem key={environment.id} value={environment.id}>
              {environment.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  )
}
export default EnvironmentSelector
